export const defaultValue = {
    id: null,
    schemaCode: null,
    schemaName: null,
    description: null,
    bin: null,
    cardRangeStart: null,
    cardRangeEnd: null,
    cardLength: 16,
    cardNetworkCode: null,
    issuerId: null,
    isActive: true,
    createdAt: null,
    updatedAt: null,
};
